// Dependencies imports
import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";

// Style imports
import Lin from "./LineChart.module.scss";
import config from "../../config/aws-exports";

// Component linechart
const LineChart = ({ data }) => {
  const [aclass, setAClass] = useState("week");
  const [labelDates, setLabelDates] = useState([]);
  const [gpData, setGpData] = useState([]);

  // Load week data by default
  useEffect(() => {
    ConvertData(7);
  }, [data]);

  const ConvertData = (val) => {
    if (!data || Object.keys(data).length === 0) {
      setLabelDates([]);
      setGpData([]);
      return;
    }

    // Convert object to array and sort by date
    const sortedData = Object.entries(data)
      .map(([date, count]) => ({
        TS: new Date(date),
        UC: count,
      }))
      .sort((a, b) => a.TS - b.TS);

    // Get last N records
    const tarray =
      sortedData.length > val
        ? sortedData.slice(sortedData.length - val)
        : sortedData;

    const labels = tarray.map((item) =>
      item.TS.toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
      }),
    );

    const values = tarray.map((item) => item.UC);

    setLabelDates(labels);
    setGpData(values);
  };

  // Graph Data
  const Gdata = {
    labels: labelDates,
    datasets: [
      {
        label: "No. of Users",
        data: gpData,
        fill: false,
        backgroundColor: config.main_color_1,
        borderColor: config.main_color_1,
        borderWidth: 2,
        pointRadius: 4,
        pointBackgroundColor: config.main_color_1,
        tension: 0.4,
      },
    ],
  };

  // Chart Options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
        align: "end",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  const styles = {
    display: "flex",
    alignContent: "flex-start",
  };

  const toggleClass = (val) => {
    setAClass(val);
  };

  return (
    <div>
      <div style={styles}>
        <div>
          <button
            className={
              aclass === "week" ? Lin.graphbuttonactive : Lin.graphbutton
            }
            onClick={() => {
              toggleClass("week");
              ConvertData(7);
            }}
          >
            Week
          </button>

          <button
            className={
              aclass === "Month" ? Lin.graphbuttonactive : Lin.graphbutton
            }
            onClick={() => {
              toggleClass("Month");
              ConvertData(30);
            }}
          >
            Month
          </button>

          <button
            className={
              aclass === "Year" ? Lin.graphbuttonactive : Lin.graphbutton
            }
            onClick={() => {
              toggleClass("Year");
              ConvertData(365);
            }}
          >
            Year
          </button>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          height: "400px",
          padding: "20px",
        }}
      >
        <Line data={Gdata} options={options} />
      </div>
    </div>
  );
};

export default LineChart;
